jQuery(document).ready(function($){

    $('[data-modal-open]').click(function() {
        let $el = $('#' + $(this).data('modal-open'));

        if ($el.length) {
            $el[0].showModal();
        }
    });

    $('a[href^="#modal"]').click(function(event) {
        let slug = $(this).attr('href').substr(1);
        let $el = $('#' + slug);

        if ($el.length) {
            $el[0].showModal();
        }

        event.preventDefault();
        return false;
    });

    $('dialog').click(function(event) {
        if (event.target !== this) {
            return;
        }

        this.close();
    });

});
